// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hrdashboardpg-inline-1 {
  padding: 0;
}

.hrdashboardpg-inline-2 {
  font-weight: 600;
}

.hrdashboardpg-inline-3 {
  flex: 1 1;
  font-size: 12px;
  font-weight: 600;
}

.hrdashboardpg-inline-5 {
  font-size: 12px;
  font-weight: 600;
}

.hrdashboardpg-inline-6 {
  padding: 0;
}

.hrdashboardpg-inline-7 {
  font-weight: 600;
}

.hrdashboardpg-dyn-1 {
  border-left: var(--hrdashboardpg-1-border-left);
}

.hrdashboardpg-dyn-2 {
  color: var(--hrdashboardpg-2-color);
}

.hrdashboardpg-dyn-3 {
  color: var(--hrdashboardpg-3-color);
}

.hrdashboardpg-dyn-4 {
  text-align: center;
  padding: 16px;
  color: var(--hrdashboardpg-4-color);
  font-size: 12px;
}

.hrdashboardpg-dyn-5 {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  border-bottom: var(--hrdashboardpg-5-border-bottom);
}

.hrdashboardpg-dyn-6 {
  font-size: 11px;
  color: var(--hrdashboardpg-6-color);
  font-weight: 600;
  min-width: 80px;
}

.hrdashboardpg-dyn-8 {
  padding: 8px 0;
  border-bottom: var(--hrdashboardpg-8-border-bottom);
}

.hrdashboardpg-dyn-9 {
  font-size: 10.5px;
  color: var(--hrdashboardpg-9-color);
}

.hrdashboardpg-dyn-10 {
  font-size: 9px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/HrDashboardPg.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".hrdashboardpg-inline-1 {\n  padding: 0;\n}\n\n.hrdashboardpg-inline-2 {\n  font-weight: 600;\n}\n\n.hrdashboardpg-inline-3 {\n  flex: 1;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.hrdashboardpg-inline-5 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.hrdashboardpg-inline-6 {\n  padding: 0;\n}\n\n.hrdashboardpg-inline-7 {\n  font-weight: 600;\n}\n\n.hrdashboardpg-dyn-1 {\n  border-left: var(--hrdashboardpg-1-border-left);\n}\n\n.hrdashboardpg-dyn-2 {\n  color: var(--hrdashboardpg-2-color);\n}\n\n.hrdashboardpg-dyn-3 {\n  color: var(--hrdashboardpg-3-color);\n}\n\n.hrdashboardpg-dyn-4 {\n  text-align: center;\n  padding: 16px;\n  color: var(--hrdashboardpg-4-color);\n  font-size: 12px;\n}\n\n.hrdashboardpg-dyn-5 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 0;\n  border-bottom: var(--hrdashboardpg-5-border-bottom);\n}\n\n.hrdashboardpg-dyn-6 {\n  font-size: 11px;\n  color: var(--hrdashboardpg-6-color);\n  font-weight: 600;\n  min-width: 80px;\n}\n\n.hrdashboardpg-dyn-8 {\n  padding: 8px 0;\n  border-bottom: var(--hrdashboardpg-8-border-bottom);\n}\n\n.hrdashboardpg-dyn-9 {\n  font-size: 10.5px;\n  color: var(--hrdashboardpg-9-color);\n}\n\n.hrdashboardpg-dyn-10 {\n  font-size: 9px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
